import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import { ddmmyyyy } from '~/src/helpers/date';

export const INDEFINITELY_ACTIVE = 'бессрочно';

export const sendWidgetAnalytics = (
    label: string,
    action = 'click deactivation btn',
): void => {
    dataLayerPush({
        event: EVENTS.UAevent,
        category: CATEGORIES.vas,
        action,
        label,
    });
};

export const getCurrentActiveToDate = (activeToDate: string): string => {
    if (activeToDate === INDEFINITELY_ACTIVE) {
        return `Подключен ${activeToDate}`;
    } else {
        return `Активен до ${ddmmyyyy(new Date(activeToDate))}`;
    }
};
